module.exports = __webpack_public_path__ + "assets/img/eye-open.26bf09f4.svg";